module.exports = __webpack_public_path__ + "img/A低通锐化50.7f7f0255.png";